export const footerLinkConfig = {
  policy: [
    {
      title: 'Support contact',
      labelKey: 'support',
      labelPlaceHolder: 'Customer service',
      key: 'support',
      placeHolder: 'Email or URL',
    },
    {
      title: 'Return policy',
      labelKey: 'return',
      labelPlaceHolder: 'Return policy',
      key: 'returnPage',
      placeHolder: 'https://www.store.com/return',
    },
    {
      title: 'Terms & conditions',
      labelKey: 'term',
      labelPlaceHolder: 'Terms',
      key: 'termPage',
      placeHolder: 'https://www.store.com/terms',
    },
    {
      title: 'Privacy policy',
      labelKey: 'privacy',
      labelPlaceHolder: 'Privacy policy',
      key: 'privacyPage',
      placeHolder: 'https://www.store.com/privacy',
    },
  ],
  social: [
    {
      key: 'facebook',
      title: 'Facebook',
      placeHolder: 'https://www.facebook.com',
    },
    {
      key: 'twitter',
      title: 'Twitter (X)',
      placeHolder: 'https://www.twitter.com',
    },
    {
      key: 'instagram',
      title: 'Instagram',
      placeHolder: 'https://www.instagram.com',
    },
    {
      key: 'tiktok',
      title: 'Tiktok',
      placeHolder: 'https://www.tiktok.com',
    },
    {
      key: 'pinterest',
      title: 'Pinterest',
      placeHolder: 'https://www.pinterest.com',
    },
  ],
};
